import { ETariffFilters } from './store/initialState';

export interface IPrices {
    id: number,
    router_id: number,
    billing_city_id?: number,
    type: number,
    value: number,
    duration: number | null,
    sort?: number,
    access_mode?: string,
}

export enum ESteps {
    tariffInfo = 'tariffInfo',
    subscriptions = 'subscriptions',
    equipments = 'equipments',
    equipmentsTv = 'equipmentsTv',
    equipmentsCottage = 'equipmentsCottage',
    address = 'address',
    contacts = 'contacts',
    agreementCreated = 'agreementCreated',
    timeSlots = 'timeSlots',
    final = 'final',
}

/**
 * Тип query-параметров для для фильтрации тарифов на станице
 */
export interface ITariffQueryParams {
    salePackageId?: string,
    tariffName?: string, // TODO использовать salePackageId вместо alias
    monoTariff?: 'true' | 'false', // TODO при использовании salePackageId - отпадет необходимость в параметре monoTariff
    tariffLine?: string,
    filters?: ETariffFilters[],
    landingAvailable?: string,
}
